export default {
	section_main_banner: {
		title: {
			one: 'Empower',
			two: 'Your',
			three: 'Transactions',
			four: 'with',
			five: 'Cryptographic',
			six: 'Assets',
		},
		description: {
			one: 'With our platform, payments can be made instantly and',
			two: 'seamlessly, without the need to exchange your',
			three: 'cryptographic assets-ensuring speed,',
			four: 'security & convenience.',
		},
		cta_buttons: {
			one: 'Starting to sign up',
		},
	},
	section_safety_speed: {
		cards: {
			one: {
				title: 'Safety and speed at the same time',
				description: {
					one: 'Experience the fastest and most reliable payment system',
					two: 'combining the proven stability of blockchain',
					three: "technology with the innovation of JP WOLRD PAY's",
					four: 'unique platform, which delivers unprecedented speed,',
					five: 'security, and seamless transactions.',
				},
			},
			two: {
				title: 'Free Registration',
				description: {
					one: 'You only need an email address and some',
					two: 'basic information about your business.',
				},
			},
			three: {
				title: 'Start Payment',
				description: {
					one: 'Once you confirm your email,',
					two: 'company name & link your account,',
					three: 'your sales prep is complete.',
				},
			},
		},
		title: "JP WORLD PAY's safety and speed",
		cta_button: 'Starting to sign up',
	},
	section_use: {
		title: 'JP WOLRD PAY is easy for anyone to use',
		cards: {
			one: {
				title: 'Secure payment',
				description:
					'JP WOLRD PAY will not disclose your personal information during QR code transactions.',
			},
			two: {
				title: 'Any company',
				description:
					'Make instant and secure payments at participating offline merchants, 24 hours a day, anywhere.',
			},
			three: {
				title: 'Touch free',
				description:
					"Don't worry about cash or credit cards, just open the app and pay.",
			},
		},
	},
	section_free: {
		title_point: 'Enjoy Shopping Anywhere',
		title: 'We Offer It For Free',
		title_description: {
			one: 'JP WOLRD PAY',
			two: ' offers the best technology, the best service, ',
			three:
				'and the best platform - all completely free. Experience premium features without the premium price.',
			four: 'Start growing your business with zero upfront cost. Join the future of seamless and secure payments today.',
		},
		cards: {
			one: {
				title: 'Ideal Crypto Wallet',
				description: {
					one: 'Make a cryptocurrency wallet that you',
					two: 'want in JP WORLD PAY.',
				},
			},
			two: {
				title: 'Shop Smarter',
				description: {
					one: 'Please choose JP WORLD PAY',
					two: 'when you are shopping.',
				},
			},
			three: {
				title: 'Pay With Us',
				description: {
					one: 'Pay with the cryptocurrency you want',
					two: 'on JP WORLD PAY.',
				},
			},
		},
		button: 'Create A Free Account',
	},
	section_world: {
		title_point: 'Fastest Payment System',
		title: {
			one: 'It Can Be Used',
			two: 'Anywhere In The World',
		},
		title_description: {
			one: 'JP WORLD PAY offers a seamless and flexible payment experience without the need for a credit card.',
			two: "Whether you're shopping online or in-store, all you need is a Wi-Fi connection to make instant",
			three:
				'payments using a simple QR code. JP WORLD PAY also supports offline payments through kiosks and',
			four: 'POS machines, letting you complete transactions anytime, anywhere — no cards,',
			five: 'no hassle, just fast, secure payments.',
		},
		button: 'Getting Started For Free',
	},
	section_member: {
		title_point: 'Enjoy Shopping Anywhere',
		title: 'Free for Business Members',
		title_description: {
			one: 'One Tether works without a credit card.',
			two: 'Just connect to wi-fi to pay instantly via QR code-Even',
			three: 'offline through kiosks and pos Machine.',
		},
		button: 'Open A Business Store',
	},
};
